import { render, staticRenderFns } from "./ITag.vue?vue&type=template&id=60773aa8&scoped=true&"
import script from "./ITag.vue?vue&type=script&lang=js&"
export * from "./ITag.vue?vue&type=script&lang=js&"
import style0 from "./ITag.vue?vue&type=style&index=0&id=60773aa8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60773aa8",
  null
  
)

export default component.exports